// ==========================================================================
// StarPlayer Tracker
// ==========================================================================
import { cloneDeep } from '../utils/objects';
import { on } from '../utils/events';

class Tracker {
  constructor(player) {
    this.player = player;
    this.playedTimeWithSpeed = 0;
    this.playedTime = 0;
    this.duration = 0;
    this.start = 0;
    this.ticks = 0;
    this.accountList = [];
    this.currentPosition = 0;

    on.call(player, player.media, 'loadeddata', () => {
      //player.debug.log('tracker -- OpenState.OPENED');
      this.start = parseInt(player.currentTime, 10);
      this.duration = parseInt(player.duration, 10);
    });

    on.call(player, player.media, 'playing', () => {
      this.duration = parseInt(player.duration, 10);
      this.ticks = new Date().getTime();
    });

    on.call(player, player.media, 'timeupdate', () => {
      if (this.player.playing) {
        this.currentPosition = parseInt(player.currentTime, 10);
        this.accumulateTime(new Date().getTime());
      }
    });

    on.call(player, player.media, 'seeked', () => {
      player.debug.log('tracker -- PlayState.SEEKED', player.beforeTime, player.currentTime);
      this.positionChanged(parseInt(player.currentTime, 10), parseInt(player.beforeTime, 10));
    });

    // on.call(player, player.media, 'emptied abort error stalled', () => {
    //     // player.debug.log('tracker -- OpenState.CLOSED');
    // });

    // on.call(player, player.elements.container, 'pause', () => {
    //     // player.debug.log('tracker -- PlayState.PAUSED');
    // });

    // on.call(player, player.elements.container, 'ended', () => {
    //     // player.debug.log('tracker -- PlayState.COMPLETE');
    // });

    // on.call(player, player.elements.container, 'waiting', () => {
    //     player.debug.log('tracker -- PlayState.BUFFERING_STARTED');
    // });

    // on.call(player, player.elements.container, 'canplay', () => {
    //     player.debug.log('tracker -- PlayState.BUFFERING_ENDED canplay');
    // });

  }

  positionChanged(newPos, oldPos) {
    if (oldPos > this.start) {
      this.accountList.push([this.start, oldPos]);
    }
    this.start = newPos;
  }

  accumulateTime(ticks) {
    if (this.ticks == 0) {
      this.ticks = ticks;
    }

    const speed = this.player.speed;
    const temp = ticks - this.ticks;
    if (temp > 0 && temp < 5000) {
      this.playedTimeWithSpeed += temp * speed.toFixed(1) / 1000;
      this.playedTime += temp / 1000;
    } else {
      this.player.debug.log('!!!!', temp);
    }
    this.ticks = ticks;

    // if (this.player.config.debug) {
    //     this.player.debug.log('Tracker Percent', this.getTrackerTimePercent.call(this));
    //     this.player.debug.log('History', this.getHistory.call(this));
    //     this.player.debug.log('Tracker', this.getTracker.call(this));
    // }
  }

  getPlayedTimeWithSpeed = () => {
    return parseInt(this.playedTimeWithSpeed, 10);
  }

  getPlayedTime = () => {
    return parseInt(this.playedTime, 10);
  }

  getHistory = () => {
    let list_copy = cloneDeep(this.accountList);
    let end = this.currentPosition;
    if (end < this.start)
      end = this.start;
    list_copy.push([this.start, end]);

    let result = [];
    const length = list_copy.length;
    for (let i = 0; i < length; i++) {
      result.push([list_copy[i][0], list_copy[i][1]].join(':'));
    }
    return result.join(',');
  }

  setHistory = (history) => {
    if(history !== null && history !== undefined) {
      const temp = history.replace(/:/g, ',').split(',');
      const length = temp.length;
      for (let i = 0; i < length; i += 2) {
        this.accountList.push([temp[i], temp[i + 1]]);
      }
    }
  }

  getTrackerTime = () => {
    let list_copy = cloneDeep(this.accountList);
    let end = this.currentPosition;
    if (end < this.start)
      end = this.start;
    list_copy.push([this.start, end]);

    list_copy.sort((a, b) => { return a[0] - b[0] });
    let total, a_start, a_end, b_start, b_end;
    total = 0, a_start = 0, a_end = 0, b_start = 0, b_end = 0;

    const length = list_copy.length;

    if (length > 0) {
      a_start = Number(list_copy[0][0]);
      a_end = Number(list_copy[0][1]);

      for (let i = 1; i < length; i++) {
        b_start = Number(list_copy[i][0]);
        b_end = Number(list_copy[i][1]);

        if (b_end != b_start) {
          var pos = a_end;
          if (pos > b_start) {
            a_end = b_start;
          }
          if (pos > b_end) {
            b_end = pos;
          }
          if (a_end - a_start > 0) {
            total += (a_end - a_start);
          }
          a_start = b_start;
          a_end = b_end;
        }
      }
    }

    if (a_end - a_start > 0)
      total += (a_end - a_start);

    return total;

  }

  getTrackerTimePercent = () => {
    if (this.duration == 0)
      return 0;
    let total = this.getTrackerTime();
    return parseInt(total / this.duration * 100, 10);
  }

  getTracker = () => {
    let result = [];

    let list_copy = cloneDeep(this.accountList);
    let end = this.currentPosition;
    if (end < this.start)
      end = this.start;
    list_copy.push([this.start, end]);

    list_copy.sort((a, b) => { return a[0] - b[0] });
    let total, a1, b1, a2, b2;
    total = 0, a1 = 0, b1 = 0, a2 = 0, b2 = 0;

    const length = list_copy.length;

    if (length > 0) {
      a1 = Number(list_copy[0][0]);
      b1 = Number(list_copy[0][1]);
      for (let i = 1; i < length; i++) {
        a2 = Number(list_copy[i][0]);
        b2 = Number(list_copy[i][1]);

        if (a2 != b2) {
          var pos = b1;
          if (pos > a2 && pos < b2) {
            b1 = b2;
          }

          if (pos < a2) {
            result.push([a1, b1].join(':'));
            a1 = a2;
            b1 = b2;
          }
        }
      }
      result.push([a1, b1].join(':'));
    }
    return result.join(',');
  }


}

export default Tracker;